import { render, staticRenderFns } from "./ActionFavorites.vue?vue&type=template&id=536ecfcd&scoped=true&shadow"
import script from "./ActionFavorites.vue?vue&type=script&lang=js&shadow"
export * from "./ActionFavorites.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ActionFavorites.vue?vue&type=style&index=0&id=536ecfcd&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "536ecfcd",
  null
  ,true
)

export default component.exports